import { render, staticRenderFns } from "./QLeadDataTable.vue?vue&type=template&id=c0ca5fe4&scoped=true&"
import script from "./QLeadDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeadDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeadDataTable.vue?vue&type=style&index=0&id=c0ca5fe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ca5fe4",
  null
  
)

export default component.exports